import React, { useState, useEffect } from 'react';
import { Box, Flex } from 'rebass';
import { ReactComponent as ExclamationIcon } from '../../icons/circle-exclamation.svg';
import { ReactComponent as Close } from '../../icons/close.svg';
import { shadows, space, transitions } from '../../theme';
export const Toast: React.FC<React.ComponentProps<any>> = ({
  children,
  ...props
}) => {
  const [opening, setOpening] = useState(true);
  const [closing, setClosing] = useState(false);
  const [closed, setClosed] = useState(false);
  const timeToDeleteWhenClosing = 200;
  const openingTime = 100;

  // set closed after closing animation
  useEffect(() => {
    if (!closing) return;
    const timeout = setTimeout(() => {
      setClosed(true);
    }, timeToDeleteWhenClosing);
    return () => clearTimeout(timeout);
  }, [closing]);

  // trigger opening shortly after render
  useEffect(() => {
    const timeout = setTimeout(() => {
      setOpening(false);
    }, openingTime);
    return () => clearTimeout(timeout);
  }, []);

  if (closed) return null;

  return (
    <Flex
      alignItems="center"
      sx={{
        opacity: closing || opening ? 0 : 1,
        transition: transitions.quick,
      }}
      tx="toasts"
      variant="default"
      {...props}
    >
      <Box as={ExclamationIcon} minWidth={14} minHeight={14} />
      <Box sx={{ flexGrow: 1 }} ml={space.half}>
        {children}
      </Box>
      <Box
        as={Close}
        sx={{ cursor: 'pointer' }}
        minWidth={20}
        minHeight={20}
        onClick={() => {
          setClosing(true);
        }}
      />
    </Flex>
  );
};

export const HeaderToast: React.FC<React.ComponentProps<any>> = ({
  children,
  ...props
}) => {
  return (
    <Flex
      as={Toast}
      mt={space.two}
      width={`calc(100% - 13% - ${space.six} - ${space.six})`}
      flexDirection="row"
      justifyContent="center"
      tx={'toasts'}
      sx={{ position: 'fixed', top: 0, boxShadow: shadows.main }}
      {...props}
    >
      {children}
    </Flex>
  );
};
